import { useState } from "react";
import { CycleOfFlatThirdsPair } from "./CycleOfFlatThirdsPair";
import { CycleOfFlatThirdsMap } from "./CycleOfFlatThirdsMap";
import { DotNav } from "../../../../Comps/DotNav/DotNav";
import { OutlineBox } from "../../../../Comps/OutlineBox/OutlineBox";
import { ChapterConfig } from "../../../ChapterConfig";
import { ClearHelpers } from "../../../Helpers/ClearHelpers/ClearHelpers";
import { ChapterNavItem, ChapterNav } from "../../ChapterNav/ChapterNav";
import { ChapterRoutes } from "../../ChapterNav/ChapterRoutes";
import '../HarmonicCycles.scss'

export function CycleOfFlatThirds(props:ChapterConfig){
    const subPaths:ChapterNavItem[] = [
        {title:'Lesson', path:'lesson', element:<ClearHelpers><Lesson/></ClearHelpers>}
    ]
    return  <div className={'cycle-of-thirds-chapter'}>
                <h1>The Cycle of Flat Thirds in the HexMap</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
}

export function Lesson(){
    const width:number = 900
    const [screenIndex, setScreenIndex] = useState(0)

    const onNavClick = (navIndex:number) => {
        setScreenIndex(navIndex)
    }
    const getHexMaps = () => {return [
        <CycleOfFlatThirdsMap/>,
        <CycleOfFlatThirdsPair/>
    ]}
    const hexMaps = getHexMaps()

    return(
        <OutlineBox title={'The Cycle of Flat Thirds as a Horizontal Row'} width={width}>
            <div className={'harmonic-cycle'}>
                <div className={'harmonic-cycle-page-container'}>
                    {hexMaps[screenIndex]}
                </div>
            </div>
            <DotNav length={hexMaps.length} selectedIndex={screenIndex} onClick={onNavClick}/>
        </OutlineBox>
    )
}
